<style>
.stepsBar {
  display: flex;
  justify-content: space-between;
  max-width: 70%;
  margin: 0 auto;
  margin-top: 20px;
}
.steps {
  color: #56bae7;
  align-items: center;
  display: flex;
  flex-direction: column;
}
p.active {
  font-weight: bold;
}
hr.verify {
  margin-top: 20px;
  margin-bottom: 20px;
  border: 0;
  border-top: 1px solid #cfcfcf;
}

.stepper-wrapper {
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 12px;
  }
}
a.stepper-item {
  color: #073763;
}

.stepper-item::before {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 20px;
  left: -50%;
  z-index: 2;
}

.stepper-item::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 2;
}

.stepper-item .step-counter {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 6px;
}

.stepper-item.active {
  font-weight: bold;
}

.stepper-item.completed .step-counter {
  background-color: #ccc;
}

.stepper-item.completed::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 3;
}

.stepper-item:first-child::before {
  content: none;
}
.stepper-item:last-child::after {
  content: none;
}
.rejectionBlock {
  text-align: center;
  background-color: #fff;
  padding: 5%;
}
.rejectionBlock img {
  width: 20%;
}
.rejectionBlock h4 {
  font-size: 26px;
  margin-top: 40px;
  margin-bottom: 50px;
}
.rejectionBlock a {
  font-size: 20px;
}
</style>
<template>
  <div class="deposit-live profile-page test2" style="background: #fff; padding: 20px 0;">
    
   
    
    <!-- <div class="d-flex justify-content-left" style="padding: 20px;">
      <div class="alertmessage" style="padding:10px; border:1px solid black; background-color: #D94251; ">
        <p style="color:#ffff; ">This is the alert message</p>
      </div>
    </div> -->



    <div class="stepper-wrapper">
      <a
        @click="() => changeStep(1)"
        class="stepper-item"
        :class="store.liveAccounts.length || hasLiveAccount() ? 'completed' : '' "
      >
        <div class="step-counter">
          <i v-show="store.liveAccounts.length > 0 || hasLiveAccount()" class="far fa-check-circle fa-3x"></i>
          <i v-show=" store.liveAccounts.length == 0 && !hasLiveAccount()" class="far fa-circle fa-3x"></i>
        </div>
        <div class="step-name">
          <p :class="step == 1 ? 'active' : ''">{{$t("verify.account_creation")}}</p>
        </div>
      </a>
      <a
        @click="() => changeStep(2)"
        class="stepper-item"
        :class="isQuestion() ? 'completed' : ''"
        v-if="this.is2Step"
      >
        <div class="step-counter">
          <i v-show="isQuestion()" class="far fa-check-circle fa-3x"></i>
          <i v-show="!isQuestion()" class="far fa-circle fa-3x"></i>
        </div>
        <div class="step-name">
          <p :class="step == 2 ? 'active' : ''">{{$t("verify.financial_details")}}</p>
        </div>
      </a>
      <a
        @click="() => changeStep(3)"
        class="stepper-item"
        :class="sumsubVerified || isVerified() ? 'completed' : ''"
      >
        <div class="step-counter">
          <i v-show="sumsubVerified || isVerified()" class="far fa-check-circle fa-3x"></i>
          <i v-show="!sumsubVerified && !isVerified()" class="far fa-circle fa-3x"></i>
        </div>
        <div class="step-name">
          <p :class="step == 3 ? 'active' : ''">{{$t("verify.verification")}}</p>
        </div>
      </a>
      <a
        @click="() => changeStep(4)"
        class="stepper-item"
        :class="hasDeposit() ? 'completed' : ''"
      >
        <div class="step-counter">
          <i v-show="hasDeposit()" class="far fa-check-circle fa-3x"></i>
          <i v-show="!hasDeposit()" class="far fa-circle fa-3x"></i>
        </div>
        <div class="step-name">
          <p :class="step == 4 ? 'active' : ''">{{$t("verify.deposit")}}</p>
        </div>
      </a>
    </div>
    <hr class="verify" />
    <div class="viewVerify">
      <div class="verifyStep" v-show="step == 1">
        <div class="main-content f-left">
          <Form class="fullMob" @submit="createAccount" style="min-height:500px;justify-content:center;align-items:center;max-width:65%;margin:0 auto;">
            <div class="content-holder">
              <div class="row-sec">
                <div class="form-holder wow fadeInLeft">
                  <ul class="clearfix onclickList">
                    <li class="half-width f-left paddingRight">
                      <label for="">{{$t("verify.select_platform")}}</label>
                      <Field
                        class="form-control"
                        as="select"
                        name="platform"
                        rules="required"
                        v-model="form.platform"
                        @change="
                          form.currency ? (form.currency = '') : null;
                          form.account_type ? (form.account_type = '') : null;
                        "
                      >
                        <option value="" disabled>{{$t("verify.select_platform")}}</option>
                        <option
                          v-for="platform of availablePlatforms"
                          :value="platform.value"
                          :key="platform.value"
                        >
                          {{ platform.label }}
                        </option>
                      </Field>
                      <ErrorMessage name="platform" />
                    </li>
                    <li class="half-width f-left pr-0">
                      <label for="">{{$t("verify.select_account_type")}}</label>
                      <Field
                        class="form-control"
                        as="select"
                        name="type"
                        rules="required"
                        v-model="form.account_type"
                        @change="form.currency?form.currency = '':null"
                      >
                        <option value="" disabled>{{$t("verify.select_account_type")}}</option>
                        <option
                          v-for="account of availableAccountTypes"
                          :value="account.value"
                          :key="account.value"
                        >
                          {{ account.label }}
                        </option>
                      </Field>
                      <ErrorMessage name="type" />
                    </li>
                    <li class="half-width f-left paddingRight"
                      v-if="form.account_type != 'ZULU'"
                    ><!-- form.account_type != 'ISL' && -->
                      <label for="">{{$t("verify.select_leverage")}}</label>
                      <Field
                        class="form-control"
                        as="select"
                        name="leverage"
                        rules="required"
                        v-model="form.leverage"
                      >
                        <option value="" disabled>{{$t("verify.select_leverage")}}</option>
                        <option
                          v-for="leverage of static_vars.leverages"
                          :value="leverage.value"
                          :key="leverage.value"
                        >
                          {{ leverage.label }}
                        </option>
                      </Field>
                      <ErrorMessage name="leverage" />
                    </li>
                    <li class="half-width f-left pr-0">
                      <label for="">{{$t("verify.select_base_currency")}}</label>
                      <Field
                        class="form-control"
                        as="select"
                        name="currency"
                        rules="required"
                        v-model="form.currency"
                      >
                        <option value="" disabled>{{$t("verify.select_currency")}}</option>
                        <option
                          v-for="(value, key) in currencyList()"
                          :value="key"
                          :key="value"
                        >
                          {{ key }}
                        </option>
                      </Field>
                      <ErrorMessage name="currency" />
                    </li>
                    <li class="half-width f-left paddingRight">
                      <label for="">{{$t("verify.password")}}</label>
                      <Field class="form-control" name="password" type="password" :rules="{required: true,min:5, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?!.*[\\\/])(?=.*[!%&@#$^*?_~])\S{5,30}$/}" v-model="form.password" maxlength="15" @focusin="showPassDiv = true" @focusout="showPassDiv = false" v-if="form.platform == 'MT4'"/>
                      <Field class="form-control" name="password" type="password"  :rules="{required: true,min:8, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?!.*[\\\/])(?=.*[!%&@#$^*?_~])\S{8,30}$/}" v-model="form.password" maxlength="15" @focusin="showPassDiv = true" @focusout="showPassDiv = false" v-else/>
                      <ErrorMessage name="password" />
                      <!-- <p><strong>Note: </strong>Minimum 8 character</p> -->
                      <div id="pr-box" class="light" v-show="showPassDiv">
                        <i></i>
                        <div id="pr-box-inner">
                          <p v-if="form.platform == 'MT4'">{{$t("verify.pass_message_one")}}</p>
                          <p v-else>{{$t("verify.pass_message_two")}}</p>
                          <ul>
                            <li class="pr-numcharacters">
                              <span :class="form.password?.length >= 5 ? 'pr-ok' : ''" v-if="form.platform == 'MT4'"></span>
                              <span :class="form.password?.length >= 8 ? 'pr-ok' : ''" v-else></span># {{$t("verify.of_characters")}}
                            </li>
                            <li class="pr-useLowercase">
                              <span :class="lowercaseOK ? 'pr-ok' : ''"></span>
                              {{$t("verify.lowercase_letter")}}
                            </li>
                            <li class="pr-useUppercase">
                              <span :class="uppercaseOk ? 'pr-ok' : ''"></span>
                              {{$t("verify.capital_letter")}}
                            </li>
                            <li class="pr-useNumbers">
                              <span :class="numberOk ? 'pr-ok' : ''"></span>
                              {{$t("verify.number")}}
                            </li>
                            <li class="pr-useSpecial">
                              <span :class="SpecialCharOk ? 'pr-ok' : ''"></span>
                              {{$t("verify.special_character")}}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li class="half-width f-left pr-0">
                      <label for="">{{$t("verify.confirm_password")}}</label>
                      <Field
                        class="form-control"
                        name="Confirm Password"
                        type="password"
                        rules="required|min:5|confirmed:@password"
                        v-model="form.confirmPassword"
                        maxlength="15"
                      />
                      <ErrorMessage name="Confirm Password" />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="btn-holder t-center">
              <button type="submit" class="btn btn-yellow popup-link-holder">
                {{$t("verify.create_account")}}
              </button>
            </div>
          </Form>
        </div>
      </div>
      <div class="questionVerify" v-if="step == 2">
        <Questions :changeStep="changeStep"></Questions>
      </div>
      <div class="showVerify" v-show="step == 3">
        <Trullio :changeStep="changeStep" v-if="static_vars.trullioCountries[store.user.country.toString().trim()] && !store.user.profile.trulio_transaction_record_id && allowTrulio"></Trullio>
        <SumSub :changeStep="changeStep" :sumsubVerified="()=>sumsubVerified = true" v-else></SumSub>
      </div>
      <div v-show="step == 4">
        <Deposit />
      </div>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/store";
import snsWebSdk from "@sumsub/websdk";
import Deposit from "@/views/funds/deposit";
import { Form, Field, ErrorMessage } from "vee-validate";
import Questions from "./questions";
import SumSub from "./doc-verify/sum-sub";
import Trullio from "./doc-verify/trullio";

export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
      ipvStarted: false,
      step: 1,
      showRejectionBlock: false,
      sumsubVerified: false,
      form: {
        account_type: "",
        demo_live: "1",
        platform: "MT4",
        leverage: "",
        currency: "",
        password: "",
        confirmPassword: "",
        verificationSteps: true,
      },
      showPassDiv: false,
      lowercaseOK: false,
      uppercaseOk: false,
      numberOk: false,
      SpecialCharOk: false
    };
  },
  mounted() {
    this.showRejectionBlock = false;
    if (this.isVerified()) {
      this.changeStep(4);
    } else if (this.isQuestion() || !this.is2Step) {
      this.changeStep(3);
    } else if (this.hasLiveAccount() && this.is2Step) {
      this.changeStep(2);
    } else{
      this.changeStep(1);
    }
  },
  watch: {
    "form.password": function (val = '') {
      let lowerCase = new RegExp("[a-z]"),
        upperCase = new RegExp("[A-Z]"),
        numbers = new RegExp("[0-9]"),
        specialcharacter = new RegExp("[!,%,&,@,#,$,^,*,?,_,~]");
      if ((val || '').match(lowerCase)) {
        this.lowercaseOK = true;
      } else {
        this.lowercaseOK = false;
      }
      if ((val || '').match(upperCase)) {
        this.uppercaseOk = true;
      } else {
        this.uppercaseOk = false;
      }
      if ((val || '').match(numbers)) {
        this.numberOk = true;
      } else {
        this.numberOk = false;
      }
      if ((val || '').match(specialcharacter)) {
        this.SpecialCharOk = true;
      } else {
        this.SpecialCharOk = false;
      }
      if (
        this.lowercaseOK &&
        this.uppercaseOk &&
        this.numberOk &&
        this.SpecialCharOk &&
        (val || '').length >= 5
      ) {
        this.showPassDiv = false;
      }
    },
  },
  
  computed: {
    allowTrulio(){
      return true;/*['demo0701@yopmail.com',
          'demo0702@yopmail.com',
          'demo0703@yopmail.com',
          'demo0704@yopmail.com',
          'demo0705@yopmail.com',
          'demo0706@yopmail.com',
          'demo0707@yopmail.com',
          'demo0708@yopmail.com',
          'demo0709@yopmail.com',
          'demo0800@yopmail.com',
          'demo0801@yopmail.com',
          'demo0802@yopmail.com',
          'demo0803@yopmail.com',
          'demo0804@yopmail.com',
          'demo0805@yopmail.com','smandal@yopmail.com',

          'demo0711@yopmail.com',
          'demo0712@yopmail.com',
          'demo0713@yopmail.com',
          'demo0714@yopmail.com',
          'demo0715@yopmail.com',
          'demo0716@yopmail.com',
          'demo0717@yopmail.com',
          'demo0718@yopmail.com',
          'demo0719@yopmail.com',
          'demo0720@yopmail.com',

          'demo0806@yopmail.com',
          'demo0807@yopmail.com',
          'demo0808@yopmail.com',
          'demo0809@yopmail.com',
          'demo0810@yopmail.com',
          'demo0811@yopmail.com',
          'demo0812@yopmail.com',
          'demo0813@yopmail.com',
          'demo0814@yopmail.com',
          
          'demo1801@yopmail.com',
          'demo1802@yopmail.com',
          'demo1803@yopmail.com',
          'demo1804@yopmail.com',
          'demo1805@yopmail.com',
          'demo1806@yopmail.com',
          'demo1807@yopmail.com',
          'demo1808@yopmail.com',
          'demo1809@yopmail.com',
          'demo1810@yopmail.com',
          'demo1811@yopmail.com',
          'demo1812@yopmail.com',
          'demo1813@yopmail.com',
          'demo1814@yopmail.com',
          'demo1815@yopmail.com',
          'demo1816@yopmail.com',
          'demo1817@yopmail.com',
          'demo1818@yopmail.com',
          'demo1819@yopmail.com',
          'demo1820@yopmail.com',

          'demo2811@yopmail.com',
          'demo2812@yopmail.com',
          'demo2813@yopmail.com',
          'demo2814@yopmail.com',
          'demo2815@yopmail.com',
          'demo2816@yopmail.com',
          'demo2817@yopmail.com',
          'demo2818@yopmail.com',
          'demo2819@yopmail.com',
          'demo2820@yopmail.com',
          'demo2821@yopmail.com',
          'demo2822@yopmail.com',
          'demo2823@yopmail.com',
          'demo2824@yopmail.com',
          'demo2825@yopmail.com',
          'demo2826@yopmail.com',
          'demo2827@yopmail.com',
          'demo2828@yopmail.com',
          'demo2829@yopmail.com',
          'demo2830@yopmail.com',
          'demo2831@yopmail.com',
          'demo2832@yopmail.com',
          'demo2833@yopmail.com',
          'demo2834@yopmail.com',
          'demo2835@yopmail.com',
          'demo2836@yopmail.com',
          'demo2837@yopmail.com',
          'demo2838@yopmail.com',
          'demo2839@yopmail.com',
          'demo2840@yopmail.com',

        ].includes(this.store.user.email);*/
    },
    is2Step(){
      return true/*[34269,20081,34361,34438,34567,34587,34589].includes(this.store.user.profile.user_id)*/
    },
    availablePlatforms() {
      if (this.form.demo_live == "1") {
        return this.static_vars.platforms;
      } else {
        return this.static_vars.platforms.filter((i) => i.value != "ZTP");
      }
    },
    availableAccountTypes() {
      if (this.form.platform == "MT5") {
        return this.static_vars.accountTypes.filter(
          (i) => i.value != "ZULU"
        );/* i.value != "ISL" &&*/
      } else {
        return this.static_vars.accountTypes;
      }
      /*if (this.form.platform == "ZTP") {
        return this.static_vars.accountTypes.filter(
          (i) => i.value != "ECN" && i.value != "ECNP"
        );
      } else {
        return this.static_vars.accountTypes.filter(
          (i) => i.value == "ECN" || i.value == "ECNP"
        );
      }*/
    },
  },
  components: {
    Deposit,
    Form,
    Field,
    ErrorMessage,
    Questions,
    SumSub,
    Trullio,
  },
  methods: {
    currencyList() {
      if(this.form.account_type == 'ISL'){
        return this.static_vars.currency_ISL
      } else if (this.form.platform == "MT4") {
        return this.static_vars.currency_mt4;
      } else {
        return this.static_vars.currency;
      }
    },
    hasLiveAccount() {
      if (this.store.liveAccounts.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    isVerified() {
      if (this.store.user.verified_status) {
        return true;
      } else {
        return false;
      }
    },
    isQuestion() {
      return parseInt(this.store.user.step || 0) >= 2;
      /*if (this.store.user.verified_status) {
        return true;
      } else {
      }*/
    },
    hasDeposit() {
      if (this.store.depositsList.records.length) {
        return true;
      } else {
        return false;
      }
    },
    changeStep(step) {
      if (step == 4 && this.hasLiveAccount() && (this.isQuestion() || !this.is2Step) && this.isVerified()) {
        this.step = step;
      }else if (step == 3 && /*!this.isVerified() && */(this.isQuestion() || !this.is2Step) && this.hasLiveAccount()) {
        this.step = step;
        // setTimeout(() => {
        //   this.startIpvNow();
        // }, 300);
      }else if (step == 2 /*&& !this.isQuestion() */&& this.hasLiveAccount()) {
        this.step = step;
      }else if (step == 1/* && !this.hasLiveAccount()*/) {
        this.step = step;
      }
      
      
      // else {
      //   this.step = 1;
      // }
    },
    createAccount() {
      let form = JSON.parse(JSON.stringify(this.form));
      /*if (form.account_type == "ISL" || form.account_type == "ZULU") {
        form.leverage = "0";
      }*/
      this.store
        .createAccount(form, true)
        .then(() => {
          if (this.isVerified()) {
            if (!this.hasDeposit()) {
              this.changeStep(4);
            }
          }else if(!this.is2Step || this.isQuestion()) {
            this.changeStep(3);
          } else if(this.is2Step) {
            this.changeStep(2);
          }
          try{
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event' : 'createaccount',
              'platformType' : form.platform,
              'accountType' : form.account_type,
              'registrationStep' : '1'
            });

            //  live account
            window.dataLayer.push({
              'event' : 'registration',
              'ctaType' : 'LiveAccount',
              'ctaPosition' : window.location.href //this should be replaced with an actual page path/cta button type
            });

          }catch (ex) {
            console.log('ex', ex)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    startIpvNow() {
      let input_json = {};
      this.ipvStarted = !this.ipvStarted;
      this.store
        .getIPVToken(input_json)
        .then((response) => {
          this.intializeSumSub(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    intializeSumSub({ accesstoken, levelname }) {
      console.log(accesstoken,'sub',levelname)
      this.launchWebSdk(
        "https://api.sumsub.com",//"https://test-api.sumsub.com"
        levelname,
        accesstoken,
        this.store.user.email,
        "",
        ""
      );
    },

    launchWebSdk(
      apiUrl,
      flowName,
      accessToken,
      applicantEmail,
      applicantPhone,
      customI18nMessages
    ) {
      const _that = this;

      let snsWebSdkInstance = snsWebSdk
        .init(accessToken, () => this.store.sumSubToken.accesstoken)
        .withBaseUrl("https://api.sumsub.com")
        .withConf({
          lang: "en", //language of WebSDK texts and comments (ISO 639-1 format)
          email: applicantEmail,
          phone: applicantPhone,
          i18n: customI18nMessages, //JSON of custom SDK Translations
          uiConf: {
            customCssStr:
              "button.submit:active:not(:disabled), button.submit:hover:not(:disabled):not(.disabled):not(:active), button[type=submit]:active:not(:disabled), button[type=submit]:hover:not(:disabled):not(.disabled):not(:active), #loader .round-icon, .round-icon{ background: #073763; color: #fff; background-image:none;}button.submit, button[type=submit]{ background: #073763; color: #fff;} .step.active .title, h3, h4, .content .desktop p, .document-status h2{color:#414649} .step.active .bullet:before, .step.active.success .bullet:before, .radio-item .checkmark:after{background-color:#073763} .mobile-button .fa-icon, .accent{color:#073763} .checkbox input:checked~.checkmark{background-color:#073763 ;border-color:#073763} .step.active .line, .step.success .line{background-color:#073763} .document-status p, p, .checkbox, .radio-item{color:#888da8;}",
            // customCss: "https://url.com/styles.css"
            // URL to css file in case you need change it dynamically from the code
            // the similar setting at Customizations tab will rewrite customCss
            // you may also use to pass string with plain styles `customCssStr:`
          },
        })
        .withOptions({ addViewportTag: false, adaptIframeHeight: true })
        // see below what kind of messages WebSDK generates
        .on("idCheck.onApplicantSubmitted", (submitted) => {
          console.log("submitted", submitted);
          // console.log('stepCompleted', payload)
          // setTimeout(function () {
          //   _that.displayAvailableOption();
          // }, 15000);
        })
        .on("idCheck.onApplicantResubmitted", (payload) => {
          console.log("resubmitted", payload);
          // setTimeout(function () {
          //   _that.displayAvailableOption();
          // }, 15000);

          // if (messageType == "idCheck.applicantStatus") {
          if (
            "reviewStatus" in payload &&
            payload.reviewStatus == "completed"
          ) {
            // _that.skipDocumentUpload()

            if (
              "reviewResult" in payload &&
              "reviewRejectType" in payload.reviewResult &&
              payload.reviewResult.reviewRejectType == "RETRY"
            ) {
              setTimeout(function () {
                _that.iframeVar = true;
                _that.showFeaturesDiv = false;
                _that.asktoallowNotification = false;
              }, 15000);
            } else {
              _that.getSumSubResp();
            }
          } else if (
            "reviewStatus" in payload &&
            payload.reviewStatus == "pending"
          ) {
            // setTimeout(function () {
            //   _that.displayAvailableOption();
            // }, 15000);
          } else {
            console.log("sss");
          }
          // }
        })
        .on("idCheck.applicantStatus", (status) => {
          console.log("status", status);
          if (
            status.reviewResult &&
            status.reviewResult.reviewAnswer == "GREEN"
          ) {
            this.sumsubVerified = true;
            this.changeStep(4);
          }
          if (
            status.reviewResult &&
            status.reviewResult.reviewAnswer &&
            status.reviewResult.reviewAnswer == "RED" &&
            status.reviewResult.reviewRejectType &&
            status.reviewResult.reviewRejectType == "FINAL"
          ) {
            this.showRejectionBlock = true;
          }
          // if (
          //   "reviewStatus" in payload &&
          //   payload.reviewStatus == "completed"
          // ) {
          //   if (
          //     "reviewResult" in payload &&
          //     "reviewRejectType" in payload.reviewResult &&
          //     payload.reviewResult.reviewRejectType == "RETRY"
          //   ) {
          //     setTimeout(function () {
          //       _that.iframeVar = true;
          //       _that.showFeaturesDiv = false;
          //       _that.asktoallowNotification = false;
          //     }, 15000);
          //   } else {
          //     _that.getSumSubResp();
          //   }
          // } else if (
          //   "reviewStatus" in payload &&
          //   payload.reviewStatus == "pending"
          // ) {
          //   setTimeout(function () {
          //     _that.displayAvailableOption();
          //   }, 15000);
          // } else {
          //   console.log("sss");
          // }
        })
        .on("idCheck.onError", (error) => {
          console.log("onError", error);
        })
        .build();
      // you are ready to go:
      // just launch the WebSDK by providing the container element for it
      snsWebSdkInstance.launch("#sumsub-websdk-container");
    },
  },
};
</script>
